const CubeFace={
		BACK:'back', 
		FRONT:'front', 
		RIGHT:'right',
		LEFT:'left',
		UP:'up',
		DOWN:'down'
};
CubeFace.parse = function(value){
	if(value===undefined||value===null)
		throwCouldNotParse(value);
	if(typeof(value)==='string')
		return fromString(value);
	if(typeof(value)==='number')
		return fromNumber(value);
};
function fromNumber(value){
	switch (value){
		case 0:
			return CubeFace.BACK;
		case 1:
			return CubeFace.FRONT;
		case 2:
			return CubeFace.RIGHT;
		case 3:
			return CubeFace.LEFT;
		case 4:
			return CubeFace.UP;
		case 5:
			return CubeFace.DOWN;
	}
	throwCouldNotParse(value);
}
function fromString(value){
	value = value.toLowerCase();
	switch(value){
		case 'b':
		case 'back':
			return CubeFace.BACK;
		case 'f':
		case 'front':
			return CubeFace.FRONT;
		case 'l':
		case 'left':
			return CubeFace.LEFT;
		case 'r':
		case 'right':
			return CubeFace.RIGHT;
		case 'u':
		case 'up':
			return CubeFace.UP;
		case 'd':
		case 'down':
			return CubeFace.DOWN;
	}
	throwCouldNotParse(value);
}
function throwCouldNotParse(value){
	throw new Error(`Could not parse "${value}" to an CubeFace`);
}
export default CubeFace;